import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { celsius_to_fahrenheit } from 'src/helpers/interface_helpers';
//Types
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';
import type { Device } from 'src/types/Device';
import type { LabelProps } from '@Shelly/shelly-design-system/index';

export const buildTRVLabels = (
	method: string,
	job: ActionJob,
	labelList: LabelProps[],
): LabelProps[] => {
	const $format = get(format);
	if (/^(blu)?trv.target$/.test(method) && job.params.target_C != null) {
		labelList.push({
			value: job.params.target_C + ' °C',
			icon: 'fas fa-temperature-three-quarters',
		});
	} else if (/^(blu)?trv.boost$/.test(method) && job.params.duration != null) {
		labelList.push({
			value:
				job.params.duration +
				' ' +
				$format('action_delay_message_units_min', {
					default: 'min.',
				}),
			icon: 'fas fa-fire',
			iconColor: '--color-primary',
		});
	} else if (/^(blu)?trv.position$/.test(method) && job.params.pos != null) {
		labelList.push({
			value: job.params.pos + ' %',
			icon: 'fas fa-pipe-valve',
		});
	} else if (/^trv.ext_t$/.test(method) && job.params.ext_C != null) {
		labelList.push({
			value: job.params.ext_C + ' °C',
			icon: 'fas fa-temperature-low',
		});
	}
	return labelList;
};

export const stringifyTRVAction = (method: string, action: ActionJob, device: Device): string => {
	const $format = get(format);
	const params = action.params;
	let bluTrvMethod = method;
	let bluTrvParam = params;
	let actionStringify = '';
	if (method == 'blutrv.call' && action.params.method) {
		bluTrvMethod = action.params.method.replace('trv.set', 'blutrv.');
		bluTrvParam = action.params?.['params'] || {};
	}
	if (/^(blu)?trv.target$/.test(method)) {
		actionStringify = ` ${$format('label_target_temperature', {
			default: 'Target temperature',
		})}: ${device?.ht_ui?.temperature_unit === 'F' ? `${Math.round(celsius_to_fahrenheit(bluTrvParam.target_C))} °F` : `${bluTrvParam.target_C} °C`} , `;
	} else if (/^(blu)?trv.boost$/.test(method)) {
		actionStringify = ` ${$format('sub_settings_title_boost', {
			default: 'Boost',
		})}: ${bluTrvParam.duration} ${$format('action_delay_message_units_min', {
			default: 'min.',
		})} , `;
	} else if (/^(blu)?trv.position$/.test(method)) {
		actionStringify = ` ${$format('label_position', {
			default: 'Position',
		})} (${bluTrvParam.pos} %), `;
	} else if (/^trv.ext_t$/.test(method)) {
		actionStringify = ` ${$format('label_external_temperature_correction', {
			default: 'External temperature correction',
		})} (${bluTrvParam.ext_C} °C), `;
	} else {
		actionStringify = bluTrvMethod;
	}
	return actionStringify;
};
